import script from "./DyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DyForm.vue?vue&type=script&setup=true&lang=js"

import "./DyForm.vue?vue&type=style&index=0&id=c2a2c506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2a2c506"]])

export default __exports__